import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { tv } from "tailwind-variants";
import PlayerImg from "./assets/player.png";
import Icon from "../../icons";
import cn from "../../utils/cn";
import Typography from "../Typography";
const cardVariants = tv({
    base: "grid grid-cols-12 bg-primary-2 rounded-md p-4 gap-4 relative",
    variants: {
        size: {
            small: "w-[400px]",
            medium: "w-[512px]",
            large: "w-[960px]",
            full: "w-full",
        },
    },
    defaultVariants: {
        size: "large",
    },
});
const PLGCard = React.forwardRef(({ className, size, ...props }, ref) => (_jsx("div", { ref: ref, className: cn(cardVariants({ size }), className), ...props })));
PLGCard.displayName = "PLGCard";
const PLGCardCloseButton = ({ className, onClick, }) => (
// biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
_jsx("div", { onClick: onClick, className: "cursor-pointer", children: _jsx(Icon, { name: "x", className: cn("absolute top-4 right-4 size-5 cursor-pointer text-gray-dark transition-all duration-200 active:scale-75", className) }) }));
PLGCardCloseButton.displayName = "PLGCardCloseButton";
const PLGCardTitle = ({ className, children, }) => (_jsx(Typography, { variant: "heading-1", className: cn("col-span-12 min-h-10", className), children: children }));
PLGCardTitle.displayName = "PLGCardTitle";
const cardDescriptionVariants = tv({
    base: "text-gray-dark",
    variants: {
        size: {
            small: "line-clamp-3",
            medium: "line-clamp-4",
            large: "line-clamp-2",
            full: "line-clamp-2",
        },
    },
    defaultVariants: {
        size: "large",
    },
});
const PLGCardDescription = ({ className, size, link, children, }) => (_jsxs("div", { className: "min-h-16", children: [_jsx(Typography, { variant: "input-text", className: cn(cardDescriptionVariants({ size }), className), children: children }), _jsx("div", { children: link })] }));
PLGCardDescription.displayName = "PLGCardDescription";
const cardContentVariants = tv({
    base: "flex gap-y-4 flex-col",
    variants: {
        size: {
            small: "col-span-6",
            medium: "col-span-7",
            large: "col-span-9",
            full: "col-span-12 sm:col-span-6 md:col-span-8 lg:col-span-8 xl:col-span-9 2xl:col-span-10",
        },
    },
    defaultVariants: {
        size: "large",
    },
});
const PLGCardContent = React.forwardRef(({ className, size, ...props }, ref) => (_jsx("div", { ref: ref, className: cn(cardContentVariants({ size }), className), ...props })));
PLGCardContent.displayName = "PLGCardContent";
const cardMediaVariants = tv({
    base: "",
    variants: {
        size: {
            small: "col-span-6 h-auto",
            medium: "col-span-5 min-h-28",
            large: "col-span-3 min-h-28 ",
            full: "col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-4 xl:col-span-3 2xl:col-span-2 min-h-48",
        },
        aspectRadio: {
            video: "aspect-video",
            auto: "aspect-auto",
            square: "aspect-square",
        },
    },
    defaultVariants: {
        size: "large",
        aspectRadio: "auto",
    },
});
const PLGCardMediaContent = React.forwardRef(({ className, size, aspectRadio, ...props }, ref) => _jsx("div", { ref: ref, className: cn(cardMediaVariants({ size, aspectRadio }), className), ...props }));
PLGCardMediaContent.displayName = "PLGCardMediaContent";
const PLGCardFooter = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn("flex items-center justify-end gap-2 ", className), ...props })));
PLGCardFooter.displayName = "PLGCardFooter";
const PLGCardVideo = React.forwardRef(({ className, bg, onClick, ...props }, ref) => {
    return (_jsx("div", { ref: ref, onClick: onClick, style: { backgroundImage: `url(${bg})` }, className: cn("relative size-full cursor-pointer rounded-md bg-cover bg-no-repeat transition-all duration-200 active:scale-95", className), ...props, children: _jsx("img", { src: PlayerImg, alt: "player", className: "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 transform rounded-md" }) }));
});
PLGCardVideo.displayName = "PLGCardVideo";
const PLGCardImage = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn("flex items-center p-6 pt-0", className), ...props })));
PLGCardImage.displayName = "PLGCardImage";
export { PLGCard, PLGCardTitle, PLGCardDescription, PLGCardContent, PLGCardFooter, PLGCardMediaContent, PLGCardCloseButton, PLGCardVideo, PLGCardImage };
